/*!
 * Type constants
 */

export const NULL      = null
export const TRUE      = true
export const FALSE     = false
export const UNDEFINED = undefined
export const NAN       = NaN
